import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import BacktoTopButton from "./Components/BackToTop";
import FloatingWhatsapp from "./Components/FloatingWhtsapp";
import Footer from "./Components/Footer";
import Header from "./Components/Header";
import PageNotFound from "./Screens/404/404";
import ContactUs from "./Screens/Contactus";
import Home from "./Screens/Home";
import OfficeSpaces from "./Screens/OffisSpaces";
import PrivacyPolicy from "./Screens/PrivacyPolicy/Index";
import TandC from "./Screens/TermsandConditions";
import ScrollToTop from "./ScrollToTop";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import useGTMPageView from "./Components/useGTMPageView";
import LandingPageAffordability from '../src/pages/LandingPageAffordability'
import LandingPageLocation from '../src/pages/LandingPageLocation'
import LandingPageVirtual from '../src/pages/LandingPageVirtual'
import LandingPageMeeting from '../src/pages/LandingPageMeeting'
import { ThankYou } from "./NewComponents/sections/ThankYou";
import FreeDayPass from "./pages/FreeDayPass";
import LandingPagePerungudi from "./pages/LandingPagePerungudi";
import LandingPageAffordabilityPerungudi from "./pages/LandingPageAffordabilityPerungudi";
import LandingPageVirtualPerungudi from "./pages/LandingPageVirtualPerungudi";
import BlogListing from "./Screens/Blog/BlogListing";
import BlogDetail from "./Screens/Blog/BlogDetail";
import Services from "./Screens/Services";
import PartnerWithOffisbay from "./pages/PartnerWithOffisbay";

const App = () => {
  const location = useLocation();
  const isAffordablePage = 
  location.pathname === '/affordable-coworking-space' || 
  location.pathname === '/thank-you' ||
  location.pathname === '/mount-road-chennai' || 
  location.pathname === '/virtual-office-chennai' || 
  location.pathname === '/virtual-office-perungudi' || 
  location.pathname === '/meeting-room' || 
  location.pathname === '/affordable-coworking-space-perungudi' || 
  location.pathname === '/perungudi-chennai' || 
  location.pathname === '/free-day-pass';

  useGTMPageView();
  return (
    <>
      {!isAffordablePage && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/offis-spaces/" element={<OfficeSpaces />} />
        <Route path="/offis-spaces/:spacename" element={<OfficeSpaces />} />
        {/* <Route path='/offiss' element={<BookingScreen/>}/> */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TandC />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/affordable-coworking-space" element={<LandingPageAffordability />} />
        <Route path="/affordable-coworking-space-perungudi" element={<LandingPageAffordabilityPerungudi />} />
        <Route path="/mount-road-chennai" element={<LandingPageLocation />} />
        <Route path="/perungudi-chennai" element={<LandingPagePerungudi />} />
        <Route path="/virtual-office-chennai" element={<LandingPageVirtual />} />
        <Route path="/virtual-office-perungudi" element={<LandingPageVirtualPerungudi />} />
        <Route path="/meeting-room" element={<LandingPageMeeting />} />
        <Route path="/free-day-pass" element={<FreeDayPass />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/services" element={<Services />} />
        <Route path="/partners" element={<PartnerWithOffisbay />} />
        <Route path="/partner-with-us" element={<PartnerWithOffisbay />} />
        <Route path="/blog" element={<BlogListing />} />
        <Route path="/blog/:title" element={<BlogDetail />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
      {!isAffordablePage && <Footer />}
      <ScrollToTop />
      {!isAffordablePage && <FloatingWhatsapp />}
      <BacktoTopButton />
    </>
  );
};

export default App;
